<template>
  <section class="store-list">
    <p class="store-list__heading">
      {{ heading }}
    </p>
    <ul>
      <li
        v-for="store in stores"
        :key="store.Name"
        class="store-list__row"
      >
        <!-- Hide until favorite stores are active
        <svgicon
          class="heart-icon"
          name="Controls/Heart"
        />
        -->
        <span class="store-list__row--name">{{ store.Name }}</span>
        <button
          class="store-list__row--button button button--32 button--secondary"
          :disabled="storeMatch(store) ? true : false"
          type="button"
          :aria-label="'Välj ' + store.Name"
          @click="$emit('selectedStore', store)"
          v-text="storeMatch(store) ? 'Vald' : 'Välj'"
        />
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'StoreList',
  props: {
    stores: {
      type: Array,
      default: () => []
    },
    currentStoreId: {
      type: String,
      default: ""
    },
    heading: {
      type: String,
      default: ""
    }
  },
  methods: {
    storeMatch (store) {
      // currentStoreId can be a BMS id or an accountnumber
      return (store.AccountNumber === this.currentStoreId || store.Id === parseInt(this.currentStoreId, 10))
    },
  }
}
</script>

<style lang="scss">
  .store-list {
    &__heading {
      @include font(text, 2, "black");

      text-transform: uppercase;
      margin-bottom: 0.75rem;
      margin-top: 0;
    }

    &__row {
      @include font(text, 3, "bold");

      margin-top: 0.75rem;
      display: flex;
      justify-content: space-between;
      padding: 0 0.75rem 0.75rem;
      border-bottom: 1px solid $color-grey-special;
      align-items: center;

      .heart-icon {
        width: 1.25rem;
        height: 1.25rem;
        margin-right: 1rem;
        fill: $color-red;
      }

      &:first-of-type {
        margin-top: 0;
      }

      &--button {
        min-width: fit-content;
        margin-left: auto;

        &.button:disabled {
          background-color: $color-red-dark;
          color: $color-white;
          fill: $color-white;
        }
      }

      &--name {
        flex-grow: 1;
        height: fit-content;
        white-space: pre-wrap;
        margin-right: 1rem;
        margin-bottom: auto;
        margin-top: auto;
      }
    }
  }
</style>
